import React from 'react'

type Params = LiveDashboardContextValue['params'] & { filter?: string }

type LiveDashboardContext = Omit<LiveDashboardContextValue, 'params'>

export const useSpan = (dashboarContext: LiveDashboardContext & { params: Params }): { span: string } => {
    const [span, setSpan] = React.useState('')

    React.useEffect(() => {
        if (dashboarContext && dashboarContext.params && dashboarContext.params.mode === 'view') {
            const { params } = dashboarContext
            const hash = window.location.hash
            const breadcrumbs = hash.includes('&breadcrumbs=') ? hash.split('&breadcrumbs=')[1] : ''
            const spanFilterParmas = `${encode(params.span)}&filter=${encode(params?.filter)}${
                breadcrumbs ? '&breadcrumbs=' + breadcrumbs : ''
            }`
            setSpan(spanFilterParmas)
        }
    }, [dashboarContext])

    return { span }
}

const encode = (value: string): string => {
    return encodeURIComponent(encodeURI(value))
}
